import React from 'react';
import './masterScheduleForm.css';
import { useDispatch, useSelector } from "react-redux";
import { setMasterScheduleFormAction, setMasterScheduleTimesFormAction, setMasterCopyScheduleDaysAction } from "../../redux/rootReducer";
import { MASTER_COPY_SCHEDULE_DAYS_INITIAL, MASTER_SCHEDULE_FORM_INITIAL } from "../../redux/initialStateConstant";
import { GetScheduleThunk } from "../../redux/thunks/GetScheduleThunk";
import Tippy from "@tippyjs/react";
import { CopyScheduleThunk } from "../../redux/thunks/CopyScheduleThunk";

const MasterScheduleForm = () => {
    const dispatch = useDispatch();
    const master_schedule_form = useSelector(state => state.master_schedule_form);
    const master_copy_schedule_days = useSelector(state => state.master_copy_schedule_days);

    return (
        <div className="form form--schedule">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(setMasterScheduleFormAction(MASTER_SCHEDULE_FORM_INITIAL)) }/>
                        <div className="form__title">{ `Расписание мастера: ${ master_schedule_form.master_name }` }</div>
                    </div>

                    <div className="schedule__navs">
                        <div className="schedule__nav schedule__nav--prev"
                            onClick={ () => dispatch(GetScheduleThunk({
                                master_id: master_schedule_form.master_id,
                                date: master_schedule_form.prev_month
                            })) }
                        />
                        <div className="schedule__month-year">{ master_schedule_form.month_year }</div>
                        <div className="schedule__nav schedule__nav--next"
                             onClick={ () => dispatch(GetScheduleThunk({
                                 master_id: master_schedule_form.master_id,
                                 date: master_schedule_form.next_month
                             })) }
                        />
                    </div>

                    {
                        master_schedule_form.days.length > 0
                        ?
                            <div className="form__field">
                                <div className="schedule__week-days">
                                    <div className="schedule__week-day">Пн</div>
                                    <div className="schedule__week-day">Вт</div>
                                    <div className="schedule__week-day">Ср</div>
                                    <div className="schedule__week-day">Чт</div>
                                    <div className="schedule__week-day">Пт</div>
                                    <div className="schedule__week-day">Сб</div>
                                    <div className="schedule__week-day">Вс</div>
                                </div>
                                <div className="schedule__days">
                                    {
                                        master_schedule_form.days.map((elem, index) => {
                                            return(
                                                <div className={ `schedule__day ${ !elem.active ? 'schedule__day--inactive' : '' } ${ elem.schedule?.length > 0 ? 'schedule__day--active' : '' } ${ master_copy_schedule_days.days.includes(elem.date) ? 'schedule__day--copy' : '' }` }
                                                     key={ index }
                                                     onClick={ () => {
                                                         // Копирование расписания
                                                         if (master_copy_schedule_days.active) {
                                                             // Не добавляем дни где уже есть расписание
                                                             if (elem.schedule.length > 0) return;

                                                             // Копируем текущий масив с датами
                                                             let days_copy = [...master_copy_schedule_days.days];

                                                             if (days_copy.includes(elem.date)) {
                                                                 days_copy = days_copy.filter(el => el !== elem.date);
                                                             }
                                                             else {
                                                                 days_copy.push(elem.date);
                                                             }

                                                             dispatch(setMasterCopyScheduleDaysAction({
                                                                 ...master_copy_schedule_days,
                                                                 days: days_copy
                                                             }));
                                                         }
                                                         else {
                                                             dispatch(setMasterScheduleTimesFormAction({
                                                                 open: true,
                                                                 master_id: master_schedule_form.master_id,
                                                                 date: elem.date,
                                                                 times: elem.schedule
                                                             }));
                                                         }
                                                     } }
                                                >
                                                    <div className="schedule__date">{ elem.date ? new Date(elem.date).getDate() : '' }</div>
                                                    {
                                                        elem.schedule?.length > 0
                                                        ?
                                                            <>
                                                                <Tippy content={ 'Копирование расписания' }>
                                                                    <div className="schedule__copy"
                                                                         onClick={ (event) => {
                                                                             event.preventDefault();
                                                                             event.stopPropagation();

                                                                             dispatch(setMasterCopyScheduleDaysAction({
                                                                                 ...MASTER_COPY_SCHEDULE_DAYS_INITIAL,
                                                                                 active: true,
                                                                                 copy_day: elem.date
                                                                             }));
                                                                         } }
                                                                    />
                                                                </Tippy>
                                                                <div className="schedule__ts">
                                                                    {
                                                                        elem.schedule.map((el, index) => {
                                                                            if (index > 2) return;

                                                                            return(
                                                                                <div className="schedule__t" key={ index }>
                                                                                    { `${ el.from } − ${ el.to }` }
                                                                                </div>
                                                                            );
                                                                        })
                                                                    }
                                                                </div>
                                                            </>
                                                        : false
                                                    }
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                                {
                                    master_copy_schedule_days.active &&
                                    <div className="schedule__coping">
                                        <div className="schedule__coping-cancel"
                                            onClick={ () => {
                                                dispatch(setMasterCopyScheduleDaysAction(MASTER_COPY_SCHEDULE_DAYS_INITIAL));
                                            } }
                                        />
                                        <div className="schedule__coping-date">
                                            { master_copy_schedule_days.copy_day ? 'Копируемая дата: ' + new Date(master_copy_schedule_days.copy_day).toLocaleDateString('ru-Ru') : '' }
                                        </div>
                                        <div className="schedule__coping-dates">
                                            {
                                                master_copy_schedule_days.days
                                                ? 'Копируем на даты: ' + master_copy_schedule_days.days.map(el => (new Date(el).toLocaleDateString('ru-Ru'))).join(', ')
                                                : ''

                                            }
                                        </div>
                                        <div className={ `button ${ master_copy_schedule_days.days.length === 0 ? 'button--inactive' : '' }` }
                                            onClick={ () => {
                                                dispatch(CopyScheduleThunk({
                                                    copy_day: master_copy_schedule_days.copy_day,
                                                    days: JSON.stringify(master_copy_schedule_days.days)
                                                }));
                                            } }
                                        >Копировать</div>
                                    </div>
                                }
                            </div>
                        :
                            <div className="empty__list">Расписание отсутствует</div>
                    }
                </div>
            </div>
        </div>
    );
};

export default MasterScheduleForm;